module.exports = __webpack_public_path__ + "img/homebg2.363095ee.png";